import { useQuery, queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

export const listOrganizationsQuery = () => {
  return queryOptions({
    queryKey: ["organizations", "list"],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["listOrganizations"][200]
    > => {
      return handleClientMethod(getClient().GET("/organizations"));
    },
  });
};

export const useListOrganizations = () => {
  return useQuery(listOrganizationsQuery());
};
